import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, LogIn, Loader2, AlertCircle, Phone, Target } from 'lucide-react';
import { useAuth } from './contexts/AuthContext';

export default function Login() {
  const navigate = useNavigate();
  const { user, loginWithEmail, registerWithEmail, loginWithGoogle } = useAuth();

  const [isRegistering, setIsRegistering] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [error, setError] = useState('');

  React.useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (isRegistering) {
        if (!whatsapp.replace(/\D/g, '').length) {
          setError('WhatsApp é obrigatório para cadastro.');
          setLoading(false);
          return;
        }
        await registerWithEmail(email, password, whatsapp);
      } else {
        await loginWithEmail(email, password);
      }
      navigate('/dashboard');
    } catch (err) {
      setError(friendlyError(err.code));
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    setGoogleLoading(true);
    try {
      await loginWithGoogle();
      navigate('/dashboard');
    } catch (err) {
      setError(friendlyError(err.code));
      setGoogleLoading(false);
    }
  };

  return (
    <main className="container" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <section className="glass card" style={{ width: 'min(460px, 96%)', padding: '2rem' }}>
        <div className="section-heading compact" style={{ marginBottom: '1.5rem' }}>
          <span className="section-kicker">Acesso Seguro</span>
          <div className="login-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
            <Target size={30} color="var(--accent)" />
            <h2 style={{ fontSize: '1.3rem', margin: 0 }}>{isRegistering ? 'Criar Nova Conta' : 'Entrar no LeadsZone Maps'}</h2>
          </div>
          <p style={{ fontSize: '0.8rem', marginTop: '10px' }}>Admins têm acesso total. Clientes visualizam apenas a base de leads.</p>
        </div>

        {error && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(231,76,60,0.12)', border: '1px solid rgba(231,76,60,0.3)', borderRadius: '8px', padding: '10px 14px', marginBottom: '1rem', fontSize: '0.82rem', color: '#e74c3c' }}>
            <AlertCircle size={15} /> {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', marginBottom: '1.5rem', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <button
            type="button"
            onClick={() => setIsRegistering(false)}
            style={{ flex: 1, padding: '10px', background: 'transparent', border: 'none', color: !isRegistering ? 'var(--tl-cyan)' : 'var(--text-secondary)', borderBottom: !isRegistering ? '2px solid var(--tl-cyan)' : '2px solid transparent', fontWeight: !isRegistering ? 'bold' : 'normal', cursor: 'pointer' }}
          >
            Fazer Login
          </button>
          <button
            type="button"
            onClick={() => setIsRegistering(true)}
            style={{ flex: 1, padding: '10px', background: 'transparent', border: 'none', color: isRegistering ? 'var(--tl-cyan)' : 'var(--text-secondary)', borderBottom: isRegistering ? '2px solid var(--tl-cyan)' : '2px solid transparent', fontWeight: isRegistering ? 'bold' : 'normal', cursor: 'pointer' }}
          >
            Criar Conta
          </button>
        </div>

        <form onSubmit={handleEmailAuth} style={{ display: 'grid', gap: '0.8rem' }}>
          <div>
            <label style={{ fontSize: '0.7rem', color: 'var(--text-secondary)', display: 'block', marginBottom: '5px', letterSpacing: '0.07em' }}>E-MAIL</label>
            <input
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={{ width: '100%', padding: '10px 12px' }}
            />
          </div>
          <div>
            <label style={{ fontSize: '0.7rem', color: 'var(--text-secondary)', display: 'block', marginBottom: '5px', letterSpacing: '0.07em' }}>SENHA</label>
            <input
              type="password"
              placeholder="Sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={{ width: '100%', padding: '10px 12px' }}
            />
          </div>

          {isRegistering && (
            <div>
              <label style={{ fontSize: '0.7rem', color: 'var(--text-secondary)', display: 'block', marginBottom: '5px', letterSpacing: '0.07em' }}>WHATSAPP</label>
              <div style={{ position: 'relative' }}>
                <Phone size={14} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)', pointerEvents: 'none' }} />
                <input
                  type="tel"
                  placeholder="(11) 99999-9999"
                  value={whatsapp}
                  onChange={(e) => setWhatsapp(e.target.value)}
                  required
                  autoComplete="tel"
                  style={{ width: '100%', padding: '10px 12px 10px 34px' }}
                />
              </div>
            </div>
          )}

          <button
            type="submit"
            className="primary"
            disabled={loading}
            style={{ justifyContent: 'center', marginTop: '0.4rem' }}
          >
            {loading ? <Loader2 size={16} className="spin" /> : <LogIn size={16} />}
            {loading ? 'Aguarde...' : isRegistering ? 'Cadastrar' : 'Entrar'}
            {!loading && <ArrowRight size={16} />}
          </button>
        </form>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '1rem 0' }}>
          <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.08)' }} />
          <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>ou</span>
          <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.08)' }} />
        </div>

        <button
          className="glass"
          onClick={handleGoogleLogin}
          disabled={googleLoading}
          style={{ justifyContent: 'center', width: '100%', gap: '10px' }}
        >
          {googleLoading ? (
            <Loader2 size={16} className="spin" />
          ) : (
            <svg width="16" height="16" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          )}
          {googleLoading ? 'Conectando...' : 'Entrar com Google'}
        </button>

        <button className="glass" onClick={() => navigate('/')} style={{ justifyContent: 'center', width: '100%', marginTop: '0.6rem', fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
          Voltar para Landing Page
        </button>
      </section>
    </main>
  );
}

function friendlyError(code) {
  const map = {
    'auth/user-not-found': 'Usu\u00e1rio n\u00e3o encontrado.',
    'auth/wrong-password': 'Senha incorreta.',
    'auth/invalid-credential': 'E-mail ou senha inv\u00e1lidos.',
    'auth/too-many-requests': 'Muitas tentativas. Aguarde alguns minutos.',
    'auth/network-request-failed': 'Erro de conex\u00e3o. Verifique sua internet.',
    'auth/popup-closed-by-user': 'Login cancelado.',
    'auth/cancelled-popup-request': 'Login cancelado.',
    'auth/email-already-in-use': 'Este e-mail já está em uso. Tente fazer login.',
    'auth/weak-password': 'A senha deve ter pelo menos 6 caracteres.',
    'auth/invalid-email': 'E-mail inválido.',
  };
  return map[code] || 'Erro ao fazer login. Tente novamente.';
}
